<template>
  <div class="certificate-container">
    <div class="certificate">
      <div class="certificate-header">
        <img :src="logoUrl" alt="上海卒中学会logo" class="logo">
        <div class="project-name">上海卒中学会继续医学教育项目学分证书</div>
      </div>

      <div class="project-info">
        <div class="info-row">
          <span class="label">项目编号：</span>
          <span class="value">{{ certificateData.projectCode }}</span>
        </div>
        <div class="info-row">
          <span class="label">项目名称：</span>
          <span class="value">{{ certificateData.projectName }}</span>
        </div>
        <div class="info-row">
          <span class="label">项目时间：</span>
          <span class="value">{{ certificateData.startTime }}</span>
        </div>
      </div>

      <div class="grant-info">
        <p>
          <span class="underline-text">{{ certificateData.name }}</span>同志已按时完成本项目的课程学习，
          授予市级Ⅱ类继续医学教育学分<span class="underline-text">{{ certificateData.credit }}</span>分
          (<span class="underline-text">{{ certificateData.classHour }}</span>学时)，特发此证。
        </p>
      </div>

      <div class="certificate-footer">
        <div class="certificate-no">
          <span class="label">证书编号：</span>
          <span class="value">{{ certificateData.code }}</span>
        </div>
        <div class="seal-wrapper">
          <div class="seal-text">上海卒中学会</div>
          <img :src="sealUrl" alt="公章" class="seal">
        </div>
      </div>
    </div>
    <div class="ercode-area">
      <div id="er-code" ref="qrCode"></div>
      <div class="er-desc">扫码验证</div>
    </div>
  </div>
</template>
  
  <script>
import QRCode from 'qrcodejs2';
import { getCerificateUseInfo } from '@/http/request'
export default {
  data() {
    return {
      certificateData: {},
      logoUrl: 'https://yzk-1313353800.cos.ap-nanjing.myqcloud.com/test/shczxh-logo.png',
      sealUrl: 'https://yzk-1313353800.cos.ap-nanjing.myqcloud.com/test/shczxh-gz.png',
      qrUrl: ""
    }
  },
  created() {
    this.getDetail();
    this.qrUrl = `https://www.shanghaistroke.org.cn/#/certificate-image/${this.$route.params.id}`
  },
  mounted() {
    this.generateQRCode();
  },
  methods: {
    getDetail() {
      getCerificateUseInfo(this.$route.params.id).then(({data}) => {
        if(!data.code) {
          console.log("data", data.data)
          this.certificateData = data.data || {}
        }
      })
    },
    generateQRCode() {
      this.$refs.qrCode.innerHTML = '';
      new QRCode(this.$refs.qrCode, {
        text: this.qrUrl,
        width: 167,
        height: 167,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    }
  }
}
  </script>
  
  <style scoped>
@font-face {
  font-family: "SourceHanSansCN";
  src: url("../../fonts/SourceHanSerifSC-Bold.otf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSerifSC-ExtraLight";
  src: url("../../fonts/SourceHanSerifSC-ExtraLight.otf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSerifSC-Heavy";
  src: url("../../fonts/SourceHanSerifSC-Heavy.otf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSerifSC-Light";
  src: url("../../fonts/SourceHanSerifSC-Light.otf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSerifSC-Medium";
  src: url("../../fonts/SourceHanSerifSC-Medium.otf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSerifSC-Regular";
  src: url("../../fonts/SourceHanSerifSC-Regular.otf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "SourceHanSerifSC-SemiBold";
  src: url("../../fonts/SourceHanSerifSC-SemiBold.otf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
.certificate-container {
  position: relative;
  width: 1775px;
  height: 1229px;
  display: flex;
  justify-content: center;
  background-color: #f8f4e8;
}
.certificate {
  width: 1462px;
  margin: 0 auto;
}
.certificate-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
}
.certificate-header .logo {
  height: 128px;
  width: auto;
  margin-top: 90px;
}
.certificate-header .project-name {
  font-size: 50px;
  width: 718px;
  line-height: 80px;
  text-align: center;
  margin-top: 20px;
}
.project-info {
  margin-bottom: 40px;
}
.info-row {
  display: flex;
  align-items: center;
  font-size: 34px;
  margin-bottom: 40px;
}
.info-row .label {
  margin-right: 10px;
}
.grant-info {
  font-size: 34px;
  line-height: 80px;
}
.grant-info .underline-text {
  display: inline-block;
  position: relative;
  padding: 0 65px;
}

.underline-text::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 15px;
  width: 100%;
  height: 10px;
  border-bottom: 1px solid #000;
}
.certificate-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.certificate-no {
  font-size: 38px;
}
.certificate-no .value {
  color: #252121;
}
.seal-wrapper {
  position: relative;
  width: 320px;
  height: 320px;
}

.seal {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
}

.seal-text {
  position: absolute;
  width: 100%;
  text-align: center;
  left: 18%;
  bottom: 30%;
  font-size: 34px;
  font-weight: 500;
  z-index: 1;
  letter-spacing: 2px;
}
.ercode-area {
  position: absolute;
  top: 134px;
  right: 167px;
}
.ercode-area .er-code {
  height: 167px;
  width: 167px;
  background: #fff;
}
.er-desc {
  text-align: center;
  font-size: 36px;
}
</style>